import { useState } from "react";
import { api } from "../../../../../../../../utility/api";

export const TurnosProduccionApi = () => {
    const [cargando, setCargando] = useState(false);

    const iniciarTurno = async (data) => {
        try {
            setCargando(true);
            const response = await api.post(
                `turnos_produccion/iniciar_turno`,
                data,
            );
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const getOrdenesProduccion = async (params) => {
        try {
            setCargando(true);
            const response = await api.get(
                "turnos_produccion/listar_ordenes_produccion",
                params,
            );
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const getOrdenesEnProceso = async () => {
        try {
            setCargando(true);
            const response = await api.get(
                `turnos_produccion/ordenes_en_proceso`,
            );
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const iniciarOrdenProduccion = async (idOrden) => {
        try {
            setCargando(true);

            const response = await api.post(
                `turnos_produccion/iniciar_orden/${idOrden}`,
            );
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const actualizarTurno = async (data) => {
        try {
            setCargando(true);
            const response = await api.patch(
                `turnos_produccion/actualizar_turno`,
                data,
            );
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const getTurnosFinalizados = async (params) => {
        try {
            setCargando(true);
            const response = await api.get(
                "turnos_produccion/turnos_finalizados",
                params,
            );
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };


    const reabrirTurno = async (turnoId) => {
        try {
            setCargando(true);
            const response = await api.post("cierre_turno/reabrir_turno", {
                turno_id: turnoId,
            });
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    return {
        iniciarTurno,
        getOrdenesProduccion,
        getOrdenesEnProceso,
        iniciarOrdenProduccion,
        actualizarTurno,
        getTurnosFinalizados,
        reabrirTurno,
        
        cargando,
    };
};
